// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import { StyledTermText } from './Styled';

export const LineTermText = () => {
  return (
    <StyledTermText>
      <p className="term-title">第１条（目的）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            本要領は、アットホーム株式会社（以下「当社」といいます。）が提供するコネクト
            サービス（以下「当サービス」といいます。）を利用するために必要な条件、その他の基本的事項を定めることを目的とします。
          </p>
        </li>
      </ol>
      <p className="term-title">第２条（定義）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            本要領において「利用者」とは、当サービスを利用する方をいいます。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            本要領において「利用希望者」とは、当サービスの利用を希望する方をいいます。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            本要領において「本サイト」とは、当社が運営する不動産情報サイト「アットホーム」（スマートフォンサイト）又は、当社が提供するスマートフォン用アプリ「アットホーム」をいいます。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            本要領において「ユーザー等」とは、本サイトを閲覧する一般消費者等をいいます。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            本要領において「メッセージング」とは、利用者の物件担当者（ユーザー等からの問合せに対して対応できる利用者の従業員の方をいい、以下「物件担当者」といいます。）とユーザー等が直接メッセージの送受信をする行為をいいます。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            本要領において「当サービス用システム」とは、当サービスを利用するために利用者に提供されるシステムをいいます。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            本要領において「本契約」とは、本要領に基づき利用者と当社間で締結される、当サービスの利用契約をいいます。
          </p>
        </li>
      </ol>
      <p className="term-title">第３条（利用資格）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            当社は、アットホーム会員である方（当社が運営する不動産業務総合支援サイト「ATBB」の利用権限を有する方に限ります。）に対して当サービスの利用を認めるものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            当サービスの利用は事業所単位とし、利用希望者が本店、支店、その他の事業所等複数の事業所を有する場合は、事業所ごとに申し込むものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            第１項に規定する要件を充たす方であっても、当社の審査により、利用を認めないことがあります。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            第１項に規定する要件を充たさない方であっても、利用を認めることがあります。
          </p>
        </li>
      </ol>
      <p className="term-title">第４条（利用申込み）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            利用希望者は、当社所定の方法により当サービスを利用するために必要な設定を行うものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            利用希望者が、必要な設定を完了し、当サービスの利用が可能となったときに、当該利用希望者と当社間で本契約が成立します。
          </p>
        </li>
      </ol>
      <p className="term-title">第５条（当サービスの内容）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            当サービスは、以下の各号に掲げる機能を有する当サービス用システムを提供するサービスです。
          </p>
          <ol className="term-sub-list">
            <li className="term-sub-list-item">
              利用者が本サイトに掲載した物件情報への問合せボタンの表示・非表示、その他利用者の定休日や営業時間等の店舗情報の登録等の設定を行う機能。
            </li>
            <li className="term-sub-list-item">
              利用者が本サイトに公開している物件情報に設置した問合せボタンから問合せを行ったユーザー等のLINEアカウントとメッセージングができる機能。なお、利用者が管理するスマートフォンに当システム用アプリをインストールすることにより、スマートフォンからメッセージングを行うことも可能です。
            </li>
            <li className="term-sub-list-item">
              当サービス用システムにログインするための「スタッフID」を発行する機能。
            </li>
          </ol>
        </li>
        <li className="term-list-item">
          <p>
            当サービスの詳細、当サービス用システムの利用方法等は、当社所定の各種資料等に記載します。
          </p>
        </li>
      </ol>
      <p className="term-title">第６条（通信の秘密）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            当社は、電気通信事業法（昭和59年法律第86号）第4条に基づき、利用者の通信の秘密を守ります。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            当社は、次の各号に該当すると当社が判断する場合、利用者への事前告知なしに、利用者の通信の秘密にかかわる情報を閲覧又は削除することができるものとします。
          </p>
          <ol className="term-sub-list">
            <li className="term-sub-list-item">
              刑事訴訟法（昭和23年法律第131号）又は犯罪捜査のための通信傍受に関する法律（平成11年法律第137号）の定めに基づく強制力のある処分又は裁判所の命令が行われた場合
            </li>
            <li className="term-sub-list-item">
              法令に基づく強制力のある処分が行われた場合
            </li>
            <li className="term-sub-list-item">
              特定電気通信役務提供者の損害賠償責任の制限及び発信者情報の開示に関する法律（平成13年法律第137号）第4条に基づく開示請求の要件が充足されたと当社が判断した場合
            </li>
            <li className="term-sub-list-item">
              他人の生命、身体、財産又は名誉、プライバシーの保護のために必要があると当社が判断した場合
            </li>
            <li className="term-sub-list-item">利用者の同意がある場合</li>
            <li className="term-sub-list-item">
              当サービスの適切な運営上必要がある場合
            </li>
          </ol>
        </li>
      </ol>
      <p className="term-title">第７条（有効期間）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            本契約は、当社が当サービスの利用を認めた日から、利用者が第11条に定める手続きにより解約するときまでとします。
          </p>
        </li>
      </ol>
      <p className="term-title">第８条（情報の取扱い）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            当社は、第６条第２項各号に掲げる事由が生じない限り、当サービスにおけるユーザー等と利用者間のメッセージ内容に一切アクセス、閲覧及び利用しません。
          </p>
        </li>
      </ol>
      <p className="term-title">第９条（利用料）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>当サービスは、無料で利用することができます。</p>
        </li>
        <li className="term-list-item">
          <p>
            当社は、前条に規定する期間中であっても、当サービスの変更、経済情勢の著しい変動等の事由が生じた場合、所定の利用料等を変更することがあります。
          </p>
        </li>
      </ol>
      <p className="term-title">第１０条（当サービスの一時利用停止）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            利用者は、所定の手続きを行うことにより、当サービスの利用を一時的に利用停止（物件情報に設置した問合せボタンの非表示及びメッセージ機能の停止）することができます。
          </p>
        </li>
      </ol>
      <p className="term-title">第１１条（解約）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            利用者は、本契約の解約を希望する場合は、当サービス用システムにおいて所定の解約手続きを行うものとします。
          </p>
        </li>
      </ol>
      <p className="term-title">第１２条（利用制限及び解除）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            当社は、利用者が次の各号に該当し又は該当するおそれがあると当社が判断した場合には、当社の裁量により、当該利用者に対し当サービスの利用の一時停止又は制限もしくは利用解除等の措置を講じることができるものとします。
          </p>
          <ol className="term-sub-list">
            <li className="term-sub-list-item">
              本規約のいずれかの条項に違反した場合
            </li>
            <li className="term-sub-list-item">
              利用者と継続して連絡が取れない、その他の理由により、当サービスの提供継続が不適当であると当社が判断したとき
            </li>
            <li className="term-sub-list-item">
              利用者が支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合
            </li>
            <li className="term-sub-list-item">
              反社会的勢力等であるか、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等、反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合
            </li>
            <li className="term-sub-list-item">
              当サービスの運営、保守管理上必要であると当社が判断した場合
            </li>
            <li className="term-sub-list-item">
              利用者が第３条第１項に定める利用資格の要件を満たさなくなったとき
            </li>
            <li className="term-sub-list-item">
              その他前各号に類する事由があると当社が判断した場合
            </li>
          </ol>
        </li>
        <li className="term-list-item">
          <p>
            当社は、本条に基づき当社が行った措置により利用者に生じた不利益や損害の責任を負いません。
          </p>
        </li>
      </ol>
      <p className="term-title">第１３条（遵守事項）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            利用者は、利用者の当サービスの利用に関する不当又は不適切な行為に対し、当社が当該行為の停止又は改善等を要請したときは、この要請に従うものとします。
          </p>
        </li>
      </ol>
      <p className="term-title">第１４条（当サービスにおける注意事項）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            当サービスにて複数の物件担当者がメッセージングを行った場合、当サービス用システムではメッセージングを行った物件担当者を把握できますが、ユーザー等のLINEアカウントでは、物件担当者を判別する情報が表示されません。ユーザー等にメッセージを送信する場合は、その点にご注意ください。
          </p>
        </li>
      </ol>
      <p className="term-title">第１５条（スタッフID 管理）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            利用者は、善良な管理者の注意をもって当社の提供するスタッフIDを管理するものとし、これらを物件担当者以外の第三者（同一法人内の別店舗を含みます。）に貸与し、又は使用させることはできないものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            利用者のスタッフIDの管理不十分、使用上の過誤及び第三者による使用等により、利用者又は第三者に損害が生じた場合は、当該スタッフIDを管理する利用者が責任を負うものとし、当社は一切の責任を負わないものとします。なお、第三者の使用等が判明した場合は、利用者自らにおいてスタッフIDを変更等し、ユーザー等の個人情報や物件の販売状況の流出による損害を防止するものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            利用者は、第三者によるスタッフIDの不正使用又は不正使用の疑いを認めたときは、直ちに当社に連絡のうえ、当社の指示に従うものとします。
          </p>
        </li>
      </ol>
      <p className="term-title">第１６条（当サービスの停止）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            当社は、次の各号に掲げる事由が生じた場合は、当サービスを停止することがあります。
          </p>
          <ol className="term-sub-list">
            <li className="term-sub-list-item">
              当サービス運営用設備の保守又は工事等やむを得ないとき
            </li>
            <li className="term-sub-list-item">
              天災地変その他の不可抗力事由が発生し、又は発生する恐れがあるとき
            </li>
            <li className="term-sub-list-item">
              当サービス運営用設備に障害が発生し、又は発生する恐れがあるとき
            </li>
            <li className="term-sub-list-item">
              加入プロバイダのシステム休止等の理由により、当サービスが稼動不可能なとき
            </li>
            <li className="term-sub-list-item">
              当サービスの運営上及び障害発生等により、当サービスの全部又は一部を停止すべきものと判断したとき
            </li>
          </ol>
        </li>
        <li className="term-list-item">
          <p>
            前項の規定により当サービスを停止する場合、当社は利用者に対し、あらかじめその旨を通知するものとします。ただし、緊急やむを得ないときは、この限りではありません。
          </p>
        </li>
      </ol>
      <p className="term-title">第１７条（責任の制限）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            当社は、当サービスについて、ユーザー等からの問合せの増加、その他の利用者の特定目的への適合性を含むいかなる種類の保証も行いません。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            利用者又はユーザー等が使用する通信端末の種類や契約形態、端末設定、通信電波状態等により、または当サービス運営用設備等に障害が発生している間に当サービスを利用したユーザー等の問合せ等が正常に利用者に送信されず、利用者が受信できない場合があります。この場合、利用者に生じたいかなる損害に対しても、当社は責任を負わないものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            当サービスの利用に関連して利用者が被った損害につき、当社が、債務不履行責任又は不法行為責任を負う場合には、当社は、利用者に現実に発生した直接かつ通常の損害に限り、これを賠償する責任を負うものとし、特別な事情から生じた損害（損害の発生を予見し又は予見し得た場合を含みます。）については、責任を負わないものとします。
          </p>
        </li>
      </ol>
      <p className="term-title">第１８条（仕様等の変更・サービスの終了）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            当社は、利用者に事前に通知することなく、当サービスの仕様、名称、デザイン等の全部又は一部を変更、廃止又は追加することができるものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            当社は、当サービスの一部に当社のLINE公式アカウントを利用して当サービスを運営しています。LINEサービスの運営会社によるLINEサービスの仕様変更、利用条件変更等により当社のLINE公式アカウントの利用が制限された場合、当社は利用者に事前に通知することなく当サービスの提供を終了することができるものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            当社は、事前に当社が適当と判断する方法で利用者に通知することにより、当社の裁量で当サービスの提供を終了することができるものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            当社は、本条に基づき当社が行った措置により利用者に生じた損害について一切の責任を負いません。
          </p>
        </li>
      </ol>
      <p className="term-title">第１９条（本要領の取扱い）</p>
      <ol className="term-list">
        <li className="term-list-item">
          <p>
            当社は、必要に応じて本要領を変更することができるものとします。本要領を変更する場合、当社は、あらかじめ利用者に対して変更内容及び変更日を告知するものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            本要領のいずれかの条項又はその一部が、法令等により無効又は執行不能と判断された場合であっても、本要領等の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して効力を有するものとします。
          </p>
        </li>
        <li className="term-list-item">
          <p>
            本要領に定めのない事項については、アットホーム全国不動産情報ネットワーク利用約款、その他細目規定を準用します。
          </p>
        </li>
      </ol>
      <br />
      <br />
      <p>附則　本要領は2025年1月9日より適用します。</p>
    </StyledTermText>
  );
};

LineTermText.displayName = 'LineTermText';

export default LineTermText;
